import { createRouteContextObject } from '@shared/utils';
import { HttpContextBase } from '..';

enum HttpContextRoutes {
  GetClients,
  SyncClients,
}

export const HttpClientContext = createRouteContextObject(
  HttpContextBase.Client,
  HttpContextRoutes
);
